module.exports = __webpack_public_path__ + "img/twitter-icon.d47d36da.svg";